// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.related-device-list__child {
  margin-left: var(--base-sizes-4);
  margin-top: var(--base-sizes-1);
  position: relative;
}

.related-device-list__child:before {
  --tw-bg-opacity: 1;
  background-color: rgb(196 196 196 / var(--tw-bg-opacity));
  content: "";
  width: 6px;
  height: 1px;
  position: absolute;
  top: 50%;
  left: -11px;
}

.related-device-list__child:after {
  --tw-bg-opacity: 1;
  background-color: rgb(196 196 196 / var(--tw-bg-opacity));
  content: "";
  width: 1px;
  height: calc(100% + 4px);
  position: absolute;
  top: -4px;
  left: -12px;
}

.related-device-list__child:last-child:after {
  height: calc(50% + 5px);
}
`, "",{"version":3,"sources":["webpack://./home/autoboss/ipfabric-product/services/frontend/app/components/RelatedDeviceList/RelatedDeviceList.css","webpack://./services/frontend/app/components/RelatedDeviceList/RelatedDeviceList.css"],"names":[],"mappings":"AADA;ECEE,gCAAgC;EAChC,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,yDAAyD;EACzD,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,yDAAyD;EACzD,WAAW;EACX,UAAU;EACV,wBAAwB;EACxB,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB","sourcesContent":[".related-device-list__child {\n\n    margin-left: var(--base-sizes-4);\n\n    margin-top: var(--base-sizes-1);\n\n    position: relative\n}\n\n  .related-device-list__child:before {\n\n    --tw-bg-opacity: 1;\n\n    background-color: rgb(196 196 196 / var(--tw-bg-opacity));\n\n    position: absolute;\n\n    content: '';\n    height: 1px;\n    width: 6px;\n    left: -11px;\n    top: 50%\n}\n\n  .related-device-list__child:after {\n\n    --tw-bg-opacity: 1;\n\n    background-color: rgb(196 196 196 / var(--tw-bg-opacity));\n\n    position: absolute;\n\n    content: '';\n    width: 1px;\n    left: calc(-12px);\n    top: -4px;\n    height: calc(100% + 4px)\n}\n\n  .related-device-list__child:last-child:after {\n      height: calc(50% + 5px); /* 4px top margin and 1px line width */\n    }\n",".related-device-list__child {\n  margin-left: var(--base-sizes-4);\n  margin-top: var(--base-sizes-1);\n  position: relative;\n}\n\n.related-device-list__child:before {\n  --tw-bg-opacity: 1;\n  background-color: rgb(196 196 196 / var(--tw-bg-opacity));\n  content: \"\";\n  width: 6px;\n  height: 1px;\n  position: absolute;\n  top: 50%;\n  left: -11px;\n}\n\n.related-device-list__child:after {\n  --tw-bg-opacity: 1;\n  background-color: rgb(196 196 196 / var(--tw-bg-opacity));\n  content: \"\";\n  width: 1px;\n  height: calc(100% + 4px);\n  position: absolute;\n  top: -4px;\n  left: -12px;\n}\n\n.related-device-list__child:last-child:after {\n  height: calc(50% + 5px);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
